import React, {Component} from "react";
import Container from "../../../modules/commons/Container";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import MasterLogistikMotorSegmen from "./components/masterLogistikMotorSegmen";
import MasterLogistikMotorSubSegmen from "./components/masterLogistikMotorSubSegmen";
import MasterLogistikMotorSeries from "./components/masterLogistikMotorSeries";
import MasterLogistikMotorType from "./components/masterLogistikMotorType";
import MasterLogistikMotorVarian from "./components/masterLogistikMotorVarian";
import MasterLogistikMotorWarna from "./components/masterLogistikMotorWarna";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";

class MasterLogistikMotor extends Component {
    contents = [
        {
            title: "Segmen",
            component: <MasterLogistikMotorSegmen {...this.props} menuAccess={this.props.menuAccess}/>,
        },
        {
            title: "Sub Segmen",
            component: <MasterLogistikMotorSubSegmen {...this.props} menuAccess={this.props.menuAccess}/>,
        },
        {
            title: "Series",
            component: <MasterLogistikMotorSeries {...this.props} menuAccess={this.props.menuAccess}/>,
        },
        {
            title: "Tipe",
            component: <MasterLogistikMotorType {...this.props} menuAccess={this.props.menuAccess}/>,
        },
        {
            title: "Varian",
            component: <MasterLogistikMotorVarian {...this.props} menuAccess={this.props.menuAccess}/>,
        },
        {
            title: "Warna",
            component: <MasterLogistikMotorWarna {...this.props} menuAccess={this.props.menuAccess}/>,
        },
    ];

    render() {
        return (
            <Container>
                <Tabs>
                    <TabList>
                        {this.contents.map((content, index) => (
                            <Tab
                                key={content.title + index}
                                id={`btn_navigate_${content.title}`}
                            >
                                {content.title}
                            </Tab>
                        ))}
                    </TabList>
                    {this.contents.map((content, index) => (
                        <TabPanel key={content.title + index}>{content.component}</TabPanel>
                    ))}
                </Tabs>
            </Container>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterLogistikMotor);
